// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueBus from 'vue-bus'
import VueCookies from 'vue-cookies'
import API from './api'
import 'babel-polyfill'
import "../static/iconfont.css"
import "@/assets/css/main.scss"
import { Lazyload } from 'vant';
import 'vant/lib/index.css';
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.use(VueBus);
Vue.use(VueCookies);
Vue.use(Lazyload);
// 使用钩子函数对路由进行权限跳转
// router.beforeEach((to, from, next) => {
//   const sessionId = Vue.$cookies.get('yooc2020_user_token')  // sessionId
//   if (!sessionId && to.path.match('/admin') && to.path !== '/admin/login') {
//     // 跳转后台登录地址
//     next('/admin/login')
//   } else {
//     next()
//   }
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js